module.exports = __webpack_public_path__ + "img/ms.8fb8da88.svg";